import { Params } from '@angular/router';
import { decode, encode } from 'base64-arraybuffer';
import msgpack from 'msgpack-lite';
import _ from 'lodash-es';

export enum ConnectedEnvironment {
  Test = 'test-',
  Production = '',
  Stage = 'stage-',
}

export class RoutingUtils {
  /** Returns the base href in the form '/test-connected/', '/tools/' */
  public static get applicationBaseHref(): string {
    return document.head.querySelector('base')?.getAttribute('href') as string;
  }

  public static get origin(): string {
    // Fall back to use https://connected.herrenknecht.com if in development mode on port *1 and https://connected.herrenknecht.com if on port *7
    return window.location.origin.includes('herrenknecht.com')
      ? window.location.origin
      : window.location.port.slice(-1) === '1'
        ? 'https://connected.herrenknecht.com'
        : 'https://test-connected.herrenknecht.com';
  }

  /** Returns the parsed environment from the path name. */
  public static get idmServicesEnvironment(): ConnectedEnvironment {
    const environment = this.connectedEnvironment;
    if (environment !== ConnectedEnvironment.Test) return ConnectedEnvironment.Production;
    return environment;
  }

  /** Returns the regex environment from the path name. */
  public static get connectedEnvironment(): ConnectedEnvironment {
    const envrionmentMatcher = window.location.pathname.match(/^\/(?<environment>\w+-)?[\w-]+\/?/);
    const foundEnvironment = envrionmentMatcher?.groups?.environment ?? '';
    const mappedEnvironment = _.includes(_.values(ConnectedEnvironment), foundEnvironment);
    return (mappedEnvironment ? foundEnvironment : '') as ConnectedEnvironment;
  }

  public static relativeToAbsolutePath(relativePath: string) {
    return `${window.location.origin}${RoutingUtils.applicationBaseHref}${relativePath}`;
  }

  public static compareQueryParams(priorQueryParameters: Params, newQueryParameters: Params): [string[], string[], string[]] {
    const priorQpKeys: string[] = priorQueryParameters ? Object.keys(priorQueryParameters) : [];
    const newQpKeys: string[] = newQueryParameters ? Object.keys(newQueryParameters) : [];

    return [
      _.difference(newQpKeys, priorQpKeys),
      _.difference(priorQpKeys, newQpKeys),
      _.intersection(newQpKeys, priorQpKeys).filter((key) => newQueryParameters[key] !== priorQueryParameters[key]),
    ];
  }

  public static encodeAndCompressUriComponent(value: unknown): string {
    return encodeURIComponent(encode(msgpack.encode(value)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static decodeAndDecompressUriComponent(value: string): any {
    return msgpack.decode(new Uint8Array(decode(decodeURIComponent(value))));
  }
}
